export const LOADING = 'listicle.LOADING';
export const LOADED = 'listicle.LOADED';